import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'

import '../layout/sass/_responsiveTable.scss'
import { confirmDialog } from 'primereact/confirmdialog';
import api from '../api/api';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export const TabelaFornecedor = () => {
    const history = useHistory();
    const toast = useRef(null);
    const { user } = useContext(AuthContext);
    const [fornecedor, setFornecedor] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const confirmationToast = useRef(null)
    const [sortable, setSortable] = useState('ASC');
    const [first, setFirst] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('nome');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {
            'id': { value: "", matchMode: 'contains' },
            'nome': { value: "", matchMode: 'contains' },
        }
    });

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Fornecedor</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <Button
                        label="Importar"
                        className="p-mb-2 p-button-primary"
                        icon="pi pi-plus"
                        iconPos="left"
                        type="button"

                        onClick={() => history.push('/fornecedorcreate')}

                    />
                </div>
            </div>
        </div>

    );

    const getFornecedor = useCallback(async (event) => {
        setIsLoading(true)
        setFornecedor([])

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
            }, 250);
        }

        try {
            if (lazyParams.filters === undefined) {

                if (event === undefined) {
                    const response = await api.get(`fornecedor?sort=${sortableCampo},${sortable}`);

                    response.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })
                } else {
                    const response = await api.get(`fornecedor?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })

                }

                const respElements = await api.get(`fornecedor?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {
                const pesquisa = {
                    "id": lazyParams.filters['id'] !== undefined ? lazyParams.filters['id'].value : null,
                    "codigo": lazyParams.filters['codigo'] !== undefined ? lazyParams.filters['codigo'].value : null,
                    "nome": lazyParams.filters['nome'] !== undefined ? lazyParams.filters['nome'].value : "",
                }

                if (event === undefined) {
                    const respElements = await api.post(`fornecedor/searchFornecedor/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`fornecedor/searchFornecedor/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })
                    setTotalRecords(respElements.data.totalElements);
                }

            }

        }
        catch (error) {
            if (lazyParams !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`fornecedor?sort=nome,${sortable}`);
                    response.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })
                } else {
                    const response = await api.get(`fornecedor?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.forEach(fornecedor => {
                        setFornecedor(fornecedores => [...fornecedores, fornecedor])
                    })

                }

                const respElements = await api.get(`fornecedor?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter fornecedor', detail: error.toString() });
            }
        }

        setIsLoading(false)
    }, [lazyParams, sortable, sortableCampo]);

    useEffect(() => {
        const fetchfornecedor = async () => {
            try {
                await getFornecedor();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchfornecedor();

    }, [getFornecedor])

    const idBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.codigo}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />


            </div>
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const handleEditClick = (data) => {

        history.push(`/fornecedor/edit/${data.id}`);

    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user != null ? user.email : ""

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    const response = await api.delete(`fornecedor/${data.id}`);

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `${data.nome} removido(a) com sucesso` });
                    getFornecedor()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a fornecedor', detail: error.toString() });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getFornecedor}
                            header={header}
                            value={fornecedor}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma fornecedor encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} fornecedor`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[50, 100]}
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={lazyParams.filters}
                        >

                            {/* <Column
                                field="id"
                                header="Código"
                                sortable
                                body={idBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Código"

                            /> */}

                            <Column
                                field="codigo"
                                header="Código Fornecedor"
                                sortable
                                body={codigoBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Nome"

                            />

                            <Column
                                field="nome"
                                header="Nome"
                                sortable
                                body={nomeBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Nome"

                            />

                            <Column
                                header="Ações"
                                body={actionBodyTemplate}

                            />

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}
